import React from "react";
import {
  withSitecoreContext,
  Placeholder,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { TwoColumnProps } from "./types/TwoColumn.types";

const TwoColumn = (props: TwoColumnProps) => {
  const columnDirection = props?.rendering?.params?.['Column Direction'];
  const colDefinition = props?.rendering?.params?.['Left Percentage'];
  return (
    <>
      <div className={`two-column-layout ${columnDirection ? columnDirection : ""}`} id={props?.rendering?.uid}>
        <div className={`left-column ${colDefinition ? colDefinition : ""}`}>
          <Placeholder name="jss-leftcolumn" rendering={props.rendering as any} />
        </div>
        <div className="right-column">
          <Placeholder name="jss-rightcolumn" rendering={props.rendering as any} />
        </div>
      </div>
    </>
  );
};

export default withSitecoreContext()(TwoColumn);
